<template>
  <dialog-scroll-lock
    width="500" content-class="fill-height"
    :value="value"
    @input="$emit('input', false)"
  >
    <v-card class="fill-height overflow-auto">
      <v-card-title class="d-block">
        <div class="float-right relative ml-3 mr-n3 mt-n1" style="white-space: nowrap;">
          <btn-search class="absolute" style="right: 100%;" tooltip="Search guests" v-model="filter" />
          <v-btn icon @click="$emit('input', false)">
            <v-icon v-html="mdiClose" />
          </v-btn>
        </div>
        Guest list
      </v-card-title>
      <v-card-subtitle v-if="totals">
        Total attending: {{totals['Attending']}}<template v-if="form.separate_counts"> ({{totals['Adults']}} adult{{(totals['Adults'] == 1) ? '' : 's'}}, {{totals['Children']}} {{(totals['Children'] == 1) ? 'child' : 'children'}})</template>
      </v-card-subtitle>
      <v-divider />
      <div v-if="!filtered.length" class="px-6 py-3 font-italic grey--text" style="font-size: 12px; line-height: 16px;">No guests found</div>
      <div v-for="row, i in filtered" class="px-6 py-3">
        <div class="to" v-text="row.name" />
        <div v-for="key in fields" class="guest-data">
          <span class="font-italic grey--text mr-3">{{key}}</span>
          <template v-if="key == 'Attendees'">
            <template v-if="!getFieldValue(row, key).length">–</template>
            <template v-else>
              <div v-for="{ name, type } in getFieldValue(row, key)" class="ml-4">
                <v-icon
                  v-if="form.separate_counts"
                  style="width: 16px; height: 16px; vertical-align: text-top;"
                  v-html="(type == 'child') ? iconPathChild : mdiHumanMale"
                />{{name}}
              </div>
            </template>
          </template>
          <template v-else>{{getFieldValue(row, key) || ((getFieldValue(row, key) === 0) ? 0 : '–')}}</template>
        </div>
      </div>
    </v-card>
  </dialog-scroll-lock>
</template>


<style scoped>
.to {
  color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 700;
  white-space: pre-wrap;
  line-height: 20px;
}

.guest-data {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  margin-top: 4px;
  margin-left: 16px;
  text-indent: -16px;
  line-height: 16px;
}

.to + .guest-data {
  margin-top: 2px;
}
</style>


<script>
import BtnSearch from '@/components/BtnSearch.vue';
import iconPathChild from 'raw-loader!@/assets/icon-path-child.txt';
import { mdiClose, mdiHumanMale } from '@mdi/js';


export default {
  name: 'public-guest-list-dialog',

  components: {
    BtnSearch
  },

  props:[ 'value', 'form', 'guests' ],

  data() {
    return {
      filter: ''
    };
  },

  computed: {
    fields() {
      const fields = [];
      if (this.form.separate_counts)
        fields.push('Adults', 'Children');
      else if (!this.form.request_names)
        fields.push('Attending');
      if (this.form.request_names) {
        if (this.form.inputs.find(x => x.title == 'Attendees')?.public)
          fields.push('Attendees');
        else if (!this.form.separate_counts)
          fields.push('Attending');
      }
      return [
        ...fields,
        ...this.form.inputs.filter(x => x.public).map(x => x.title).filter(x => ![ 'Can you make it?', 'Total number of attendees', 'Attendees' ].includes(x))
      ];
    },

    totals() {
      const totals = { 'Attending': 0, 'Adults': 0, 'Children': 0 };
      for (const row of this.guests)
        for (const key of [ 'Attending', 'Adults', 'Children' ])
          totals[key] += this.getFieldValue(row, key) || 0;
      return totals;
    },

    guestsWithFilterKeys() {
      return this.guests.map(
        x => ({
          ...x,
          filterKey: [
            (x.name || ''),
            ...(x.response['Attendees'] || []).map(y => _.isObject(y) ? y.name : y).filter(y => y && (y != '–'))
          ].join('\t').toLowerCase()
        })
      );
    },

    filtered() {
      const filter = (this.filter || '').toLowerCase();
      const list = this.guestsWithFilterKeys.filter(x => x.filterKey.includes(filter));
      list.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
      return list;
    }
  },

  created() {
    Object.assign(this, { iconPathChild, mdiClose, mdiHumanMale });
  },

  methods: {
    getFieldValue(row, key) {
      try {
        const r = row.response || {};
        const { request_names, separate_counts } = this.form;
        switch (key) {
          case 'Response date':
            // return this.$options.filters.moment(row.updated_at, 'short');
            return row.updated_at;
          case 'Attending':
            if (!r['Can you make it?'])
              return null;
            if (r['Can you make it?'] == 'No')
              return 0;
            if (request_names && r['Attendees'])
              return r['Attendees'].filter(x => x.name).length;
            if (_.isObject(r['Total number of attendees']))
              return Object.values(r['Total number of attendees']).reduce((a, b) => a + b, 0);
            return r['Total number of attendees'] || 1;
          case 'Adults':
            if (!r['Can you make it?'])
              return null;
            if (r['Can you make it?'] == 'No')
              return 0;
            if (request_names && r['Attendees'])
              return r['Attendees'].filter(x => x.name && (x.type != 'child')).length;
            if (_.isObject(r['Total number of attendees']))
              return r['Total number of attendees'].adult;
            return r['Total number of attendees'] || 1;
          case 'Children':
            if (!r['Can you make it?'])
              return null;
            if (r['Can you make it?'] == 'No')
              return 0;
            if (request_names && r['Attendees'])
              return r['Attendees'].filter(x => x.name && (x.type == 'child')).length;
            if (_.isObject(r['Total number of attendees']))
              return r['Total number of attendees'].child;
            return null;
          case 'Attendees':
            return (r['Attendees'] || []).filter(x => x.name);
          default:
            return r[key];
        }
      } catch (e) {
        return null;
      }
    }
  },

  watch: {
    totals(v) {
      this.$emit('update:totals', v);
    }
  }
}
</script>
